import { combineReducers } from 'redux';
import user from './user/user.reducer';
import router from './router/router.reducer';
import node from './node/node.reducer';
import shipperPermission from './shipper-permission/shipper-permission.reducer';
import { LOGOUT_USER } from './user/user.action.type';

const appReducer = combineReducers({
  user,
  router,
  node,
  shipperPermission,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined;
  }

  return appReducer(state, action);
};
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
